import { render } from "./PengumumanPemenangDetail.vue?vue&type=template&id=fd01f2a2&scoped=true"
import script from "./PengumumanPemenangDetail.vue?vue&type=script&lang=js"
export * from "./PengumumanPemenangDetail.vue?vue&type=script&lang=js"

import "./PengumumanPemenangDetail.vue?vue&type=style&index=0&id=fd01f2a2&scoped=true&lang=css"

import exportComponent from "/var/www/html/pengadaan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd01f2a2"]])

export default __exports__